import { z } from 'zod';
import { PROFILE_TABS } from './tabs';

/** `?tab=` of profile routes; unknown values fall back to Overview. */
export const profileSearchSchema = z.object({
  tab: z.enum(PROFILE_TABS).optional().catch(undefined),
});
